import {Component, ElementRef, inject, OnInit, ViewChild} from '@angular/core';
import {CanalOperadorModel} from '../shared/model/canal/canal-operador.model';
import {CanalService} from '../shared/service/canal.service';
import {InfoCainaisOperadoresComponent} from './utils/info-cainais-operadores/info-cainais-operadores.component';
import {OperadorAtendimentoModel} from '../shared/model/usuario/operador-atendimento.model';
import {SessaoService} from '../shared/service/sessao.service';
import {SessaoContatoInformativoModel} from '../shared/model/sessao/sessao-contato-informativo.model';
import {CardFilaContatoSessaoComponent} from './utils/card-fila-contato-sessao/card-fila-contato-sessao.component';
import {ChatConversaComponent} from '../chat/chat-conversa/chat-conversa.component';
import {ContatoService} from '../shared/service/contato.service';
import {Contato} from '../shared/model/contato/contato.model';
import {UsuarioLogado} from '../shared/model/usuario/usuario-logado.model';
import {AuthService} from '../shared/service/auth.service';
import {UsuarioService} from '../shared/service/usuario.service';
import {MsgService} from '../shared/service/msg.service';
import {MethodsUtils} from '../shared/util/methods.utils';
import {MatDialog} from '@angular/material/dialog';
import {ModalComponentChatComponent} from '../shared/modais/modal-component-chat/modal-component-chat.component';
import {DispositivosEnum} from '../shared/enum/dispositivos.enum';
import {PerfilRotinaResticaoService} from '../shared/service/perfil-rotina-resticao.service';
import {ButtonPadraoComponent} from '../shared/components/button-padrao/button-padrao.component';
import {MatTooltip} from '@angular/material/tooltip';
import {ModalFiltroFilaEsperaComponent} from './modal-filtro-fila-espera/modal-filtro-fila-espera.component';
import {FilaEsperaFiltro} from '../shared/model/FilaEsperaFiltro';
import {FilaEsperaResposta} from '../shared/model/sessao/fila-espera-resposta.model';
import {BalaoInformativoComponent} from '../shared/components/balao-informativo/balao-informativo.component';

@Component({
  selector: 'app-fila-espera',
  standalone: true,
  imports: [
    InfoCainaisOperadoresComponent,
    CardFilaContatoSessaoComponent,
    ChatConversaComponent,
    ButtonPadraoComponent,
    MatTooltip,
    BalaoInformativoComponent
  ],
  templateUrl: './fila-espera.component.html',
  styleUrl: './fila-espera.component.css'
})
export class FilaEsperaComponent implements OnInit {
  private static readonly TAMANHO_PAGINA = 25;

  readonly ROTINA_ID = 21;
  readonly RESTRICAO_MOSTRA_TODA_FILE_ESPERA = 3;

  isCelular = MethodsUtils.detectar_dispositivos() === DispositivosEnum.MOBILE;
  isTablet = MethodsUtils.detectar_dispositivos() === DispositivosEnum.TABLET || MethodsUtils.detectar_dispositivos() === DispositivosEnum.IPAD;
  canaisOperadores: CanalOperadorModel[] = [];
  operadorSelecionado?: OperadorAtendimentoModel;
  canalIdSelecionado?: number;
  fila: SessaoContatoInformativoModel[] = [];
  sessaoContatoSelecionado?: SessaoContatoInformativoModel;
  contatoSelecionado?: Contato;
  usuarioLogado: UsuarioLogado = new UsuarioLogado();
  usuarioComPermissao = false;
  filtro: FilaEsperaFiltro = new FilaEsperaFiltro();
  isPrimeiraAberturaFiltros = false;

  paginaAtual = 0;
  fimDaLista = false;
  isRequisicaoFinalizada = true;
  isLoading = false;
  buscandoFila = false;
  showSkeleton = false;
  linhasSkeleton: number[] = [1, 2, 3, 4, 5, 6];

  @ViewChild('scrollableFila', { static: false }) scrollableFila!: ElementRef;

  private readonly canalService = inject(CanalService);
  private readonly sessaoService = inject(SessaoService);
  private readonly contatoService = inject(ContatoService);
  private readonly authService = inject(AuthService);
  private readonly usuarioService = inject(UsuarioService);
  private readonly perfilRotinaResticaoService = inject(PerfilRotinaResticaoService);
  private readonly msgService = inject(MsgService);
  private readonly dialog = inject(MatDialog);

  ngOnInit() {
    this.usuarioLogado = this.authService.getUsuarioLogadoClariBot();
    this.verificarUsuarioCoordenador();
    this.buscarCanaisOperadores();
  }

  verificarUsuarioCoordenador(){
    this.usuarioService.verificarUsuarioCoordenador(this.usuarioLogado.id!).subscribe({
      next: res => {
        if (!res) {
          this.buscarRestricao();
        } else {
          this.usuarioComPermissao = true;
        }
      }
    });
  }

  buscarRestricao() {
    this.perfilRotinaResticaoService.buscarPerfilRotinaRestricaoPorPerfilERotina(this.usuarioLogado.perfil!, this.ROTINA_ID).subscribe({
      next: res => {
          this.usuarioComPermissao = true;
         const restricoes = res.filter(p => p.permite).map(pe => pe.restricao!.id!);
         if (restricoes.includes(this.RESTRICAO_MOSTRA_TODA_FILE_ESPERA)) {
           this.usuarioComPermissao = true;
         } else {
           this.msgService.msgAdvertencia('Usuário sem permissão.');
         }
      }
    });
  }

  buscarCanaisOperadores() {
    this.canalService.buscarCanaisOperadores().subscribe({
      next: res => this.canaisOperadores = res
    });
  }

  carregarFila(mostrarSkeleton = true): void {
    this.carregarPagina(0, false, mostrarSkeleton);
  }

  buscarMaisFila(): void {
    if (this.fimDaLista || !this.isRequisicaoFinalizada) {
      return;
    }
    this.carregarPagina(this.paginaAtual + 1, true, false);
  }

  private carregarPagina(pagina: number, anexar: boolean, mostrarSkeleton: boolean): void {
    if (!this.canalIdSelecionado) {
      return;
    }

    this.isRequisicaoFinalizada = false;
    if (anexar) {
      this.isLoading = true;
    } else {
      this.buscandoFila = true;
      this.showSkeleton = mostrarSkeleton;
      this.paginaAtual = 0;
      this.fimDaLista = false;
    }

    this.sessaoService.buscarInformativoSessoesContatosPorCanal(
      this.canalIdSelecionado,
      this.operadorSelecionado?.idOperador ?? 0,
      pagina,
      FilaEsperaComponent.TAMANHO_PAGINA,
      this.filtro
    ).subscribe({
      next: res => this.aplicarResultadoFila(res, anexar),
      error: () => this.msgService.msgErro(anexar ? 'Erro ao buscar mais contatos da fila' : 'Erro ao carregar a fila de espera'),
      complete: () => this.finalizarCarregamentoFila(anexar)
    });
  }

  private aplicarResultadoFila(res: FilaEsperaResposta, anexar: boolean): void {
    const contatos = res.contatos ?? [];
    this.fimDaLista = !res.temProximaPagina;
    this.fila = anexar ? [...this.fila, ...contatos] : contatos;
    if (anexar) {
      this.paginaAtual++;
    }
  }

  private finalizarCarregamentoFila(anexar: boolean): void {
    this.isRequisicaoFinalizada = true;
    if (anexar) {
      this.isLoading = false;
      return;
    }
    this.buscandoFila = false;
    this.showSkeleton = false;
  }

  onScrollFila(): void {
    const element = this.scrollableFila?.nativeElement;
    if (!element || !this.isRequisicaoFinalizada || this.fimDaLista) return;
    if (element.scrollTop + element.clientHeight >= element.scrollHeight - 200) {
      this.buscarMaisFila();
    }
  }

  receberCanalOperadorEscolhido(event: any){
    this.operadorSelecionado = event.operadorAtendimento;
    this.canalIdSelecionado = event.canalId;

    this.carregarFila();
  }

  receberSessaoContatoEscolhido(event: any){
    this.sessaoContatoSelecionado = event;
    this.buscarContatoPorId(this.sessaoContatoSelecionado?.idContato ?? 0);
  }

  buscarContatoPorId(contatoId: number){
    this.contatoService.buscarContatoPorId(contatoId).subscribe({
      next: res => {
        this.contatoSelecionado = res;
        this.contatoSelecionado.temSessaoAberta = this.contatoSelecionado.sessao?.ativo;
        this.abrirCharModel();
      }
    });
  }

  abrirCharModel() {
    if (this.isCelular && this.contatoSelecionado) {
      this.dialog.open(ModalComponentChatComponent, {
        height: '90vh', width: (this.isCelular ? '100vw' : '90vw'),
        position: { bottom: '0' },
        data: { contato: this.contatoSelecionado }
      });
    }
  }

  abrirModalFiltro() {
    this.dialog.open(ModalFiltroFilaEsperaComponent, {
      width: '361px', height: '100vh',
      position: {
        top: '0',
        right: '0'
      },
      data: {
        isFiltro: true,
        filtros: this.filtro,
        isPrimeiraAberturaFiltros: this.isPrimeiraAberturaFiltros
      },
      panelClass: 'slide-modal'
    }).afterClosed().subscribe((resultado: FilaEsperaFiltro | null) => {
      if (resultado) {
        this.filtro = resultado;
        this.isPrimeiraAberturaFiltros = true;
        this.carregarFila();
      }
    });
  }
}
